import React from "react";

import Hero from "@components/shared/hero";

const LegislationHero = () => {
  return <Hero title="CRA Orders" height="50vh" />;
};

export default LegislationHero;
